module.exports = __webpack_public_path__ + "media/01 Silent Night.1b794822.mp3";